export default "__VITE_ASSET__DJelLNrN__"